import { useParams } from 'react-router';
import { RawLaborPricingsQuery } from './LaborTable';
import { EditFarmPricing, LABOR_PRICING_TYPE } from './EditPricing';
import { getFarmPath } from '../../utils/utils';

export const BASE_LABOR_NAME = 'Base Labor Rate';

export const EditFarmLabor = () => {
  const { farmId } = useParams();
  const basePath = getFarmPath(farmId, 'data/labor');
  return (
    <EditFarmPricing
      onDeleteRefetchQuery={RawLaborPricingsQuery}
      basePath={basePath}
      pricingType={LABOR_PRICING_TYPE}
      hideDelete
      canEditName={(name) => name !== BASE_LABOR_NAME}
      unit="/hr"
    />
  );
};
